<template>
  <div class="recommendation-shelf">
    <transition name="fade">
      <div
        v-if="isPresent(recommendations)"
        class="recommendation-shelf__container"
      >
        <h2 class="recommendation-shelf__title">
          {{ $t('product_recommendations.title') }}
        </h2>
        <p class="recommendation-shelf__subtitle">
          {{ $t('product_recommendations.subtitle') }}
        </p>
        <div class="recommendation-shelf__content">
          <div
            v-if="showControls"
            class="recommendation-shelf__prev-btn desktop-only"
            @click="scrollLeft"
          >
            <arrowLeft class="recommendation-shelf__arrow" />
          </div>
          <div class="recommendation-shelf__wrapper">
            <div class="recommendation-shelf__gallery">
              <recommendation-item
                v-for="(item, index) in recommendations"
                ref="recommendationItemRef"
                :key="index"
                :recommendation="item"
              />
            </div>
          </div>
          <div
            v-if="showControls"
            class="recommendation-shelf__next-btn desktop-only"
            @click="scrollRight"
          >
            <arrowRight class="recommendation-shelf__arrow" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import RecommendationItem from '~/components/product-recommendation/RecommendationItem.vue'
import isPresent from '~/utils/isPresent'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'

export default {
  name: 'RecommendationShelf',
  components: {
    RecommendationItem,
    ArrowLeft,
    ArrowRight,
  },
  computed: {
    recommendations() {
      return this.$store.getters['productRecommendationsStore/recommendations']
    },
    showControls() {
      return this.recommendations?.length > 2
    },
  },
  beforeDestroy() {
    window.bootstrapRecommendationEngine = null
    this.$store.dispatch('productRecommendationsStore/resetStore')
  },
  methods: {
    isPresent,
    scrollLeft() {
      const container = this.$el.querySelector('.recommendation-shelf__wrapper')
      container.scrollBy({ left: -300, behavior: 'smooth' })
    },
    scrollRight() {
      const container = this.$el.querySelector('.recommendation-shelf__wrapper')
      container.scrollBy({ left: 300, behavior: 'smooth' })
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/btn.scss';
@import '~/assets/css/variables.scss';
.recommendation-shelf {
  margin-top: 10px;
  padding: 10px 0px;
  border-top: 1px solid $color_line;

  &__title {
    font-size: $font_title_small;
    text-align: flex-start;
    margin-bottom: 5px;
  }

  &__subtitle {
    font-size: $font_size_default;
    margin: 0 0 15px 0;
    text-align: flex-start;
    font-weight: 400;
  }

  &__content {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  &__wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__gallery {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
  }

  &__prev-btn {
    left: 0px;
  }

  &__next-btn {
    right: 0px;
  }

  &__prev-btn,
  &__next-btn {
    color: white;
    background-color: $light-pink;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    cursor: pointer;
    border: 0;
    width: 48px;
    height: 48px;
    line-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    bottom: 50%;
    z-index: 1;

    .recommendation-shelf__arrow {
      width: 18px;
      fill: $v4_color_primary;
      transition: all 0.2s ease-in-out;
    }

    &.disabled {
      display: none;
    }

    &:hover {
      background-color: $light-pink-hover;
    }
  }
}
</style>
